export const LOAD_COUNT_INCREMENT = 'LOAD_COUNT_INCREMENT'
export const LOAD_COUNT_DECREMENT = 'LOAD_COUNT_DECREMENT'

export const SHOW_SNACKBAR_TOASTR = 'SHOW_SNACKBAR_TOASTR'
export const SHOW_SNACKBAR_TOASTR_HIDE = 'SHOW_SNACKBAR_TOASTR_HIDE'



/** WEBPACK FOOTER **
 ** ./src/actions/loading.js
 **/